import { session$ } from '@/features/auth/store'
import type { ActorContext } from '../domain/authorization'

// Builds the actor context the lifecycle use-cases pass to the authorization
// seam. Reads the current session; falls back to a system actor when signed out
// (dev/seed flows). Expand the context shape as the permission layer grows.
const getWorkItemActor = (): ActorContext => {
	const session = session$.get()
	const user = session?.user
	return {
		actorId: user?.id ?? 'system',
		actorName: user?.fullName ?? 'Sistema',
		companyRole: user?.companyRole,
		teamIds: user?.teamIds,
	}
}

export { getWorkItemActor }
